import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'

const messages = {}
const files = require.context('../../static/locales', true, /\.json$/)

files.keys().forEach(path => {
  const languages = files(path)
  Object.keys(languages).forEach(lang => {
    store.dispatch('i18n_addAllowedLang', lang)
    messages[lang] = languages[lang]
  })
})

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'en',
  messages
})



// WEBPACK FOOTER //
// ./src/locales/index.js